module.exports = " <div class=address-display> <div class=row> <label class=\"col-sm-4 control-label\">{{ field.label }}</label> <div class=col-sm-8> {{ field.value }}<br/> <span class=text-muted>Latitude: {{ field.latitude }}<br/>Longitude: {{ field.longitude }}</span> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/displays/AddressDisplay.vue
// module id = 700
// module chunks = 2